<template>
  <v-stripe-login-modal v-if="false" :trans="trans">
  </v-stripe-login-modal>

  <div class="container">
    <div class="code-bg">
      <transition name="product">
        <div v-if="product" class="row gx-lg-72 px-32 px-sm-48 px-lg-0">
          <div class="col-12 col-lg-5 offset-lg-1">
            <div class="top-section">
              <div class="title">{{ product.price.product_name }}</div>

              <div class="price">
                <div class="h4">{{ product.total_with_taxes.string }}</div>

                <div class="price-type">
                  <span>per</span>
                  <span class="type">{{ product.price.interval }}</span>
                </div>
              </div>

              <div class="lh-xl">
                {{ product.price.product_description }}
              </div>
            </div>

            <div class="bottom-section row">
              <div class="col-12 col-sm-2 mb-16 mb-sm-0">
                <div class="image-container">
                  <img
                    alt="Logo Evergine"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABHCAYAAAB/AKuwAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPzSURBVHgB7ZyNcdswDIXhXgfICBohI6gTNBukG8QbmBsknaDpBMkG6ga5TsBs4G7wSp2UnGNL5t+jCNv57nT5sQURFkk8gpBFFAPgyh0dOGzkFOidFiK94+ByLZpxDbxxx3Zs7FoycTYa8GlEK6PDdqex/YeZ1Svd+Y/g8ks0M+PwvSSCoVczsTiBXjhHKwngY69mYEQzroFPRxrfSSTunB/gYkUzgQ7fRNjbn1sZ3IpmAh3u3xMUZMAPJk+iGcRpOBNg7+IljY+tzyEcn1tTOElJk+wUCgQTnLCk8dHO2LTgchbBZI5uwt4GXM5C0vi43bFXQtIES6oqkBx+X1fjAtfHG/AwuFBJw6TvjWxJY6QSXwLfZ4TLszt+Co9XdzyKVtwdvgaXd+ENXuqfKmkwbEvc0eyiYFoKnGmCLmnw0ee8LD0WSEu5/z0gD+q+CQ4DaHqWHgulpTAMnS3SoEoazPucdh134j24dEeutUYajRDBcd3axtiqkpZyr78gDiNE4Pc5LkuPCisJ9542wl6JYBJyE8OiNSqmpRAuediSJtRni5AgA34wCZYIGIaUL8i8CJlIn43P2B24RA87DOvqYzRCBPE5gfksPZTstOG45CkhaVLo5gyqSUtheo6yWFbS+Gj3jalLS+EwyGQXSe3Zz80JdL4G5/IgmeCj5Cm9Pk5l/WasmqQJcPRtuNWSND6GdTUU77RhmGaye/WETQsepk/KMqtbX1er1W8h4Wy9uh9sXdjf5EZ4XIXoshhaIYJBt3qrJyLslQmgyEtF7VIyLUUpTEJJGQfORNsIERw63EoGWKL6FnkyxwgRTA+76ILRPZsWXMzURVqkYcF/9KKbuVaS4MaS1bdImzOW1HDR+x1YOieAsFTULjVWEibSHjuY+IMc4iRPI0QQnpZqAu3VyQlgkDw2wFgJSRM6CoKCDGpW38IvB2gCeOeascOu9dirnxPAccljhAjShp312LTgEh9AMS95NKWl1jP2NuCS7jOmSzw0paUOJA+0Vd/icF2dtWqYsW+Rx/2ezXLr4wxH+yDTb2x3qL/TNkc72qsjaWpBdrgbbcaWovgwohkUGHbgYqG8F7bgsh1tMvKib5z1A0VTmNGuAYeLeKBo0mFwon2P3m8twQJpKeTfJPUPFC1SfYu8LH0jWsGCGg7pgcuIZrDwSiLhepcXTOCvAY/dCr44SRO0YYVwyUOvvqWCitW3CJc8jWgFCqpv4Q8yZ/mFG3SHMS95LD4lTXBb5qpiqdW3dKCs+haHWfpPSZPQpv0gQ5M0X6UM7AW8GQs+k3Hn/3Mf3Df363d3/HV//xHNgJsv1D3sHCspxDj8Wsnnue9Fopj/0BVQlv6blVAAAAAASUVORK5CYII="
                  />
                </div>
              </div>

              <div class="col-12 col-sm-9">
                <div class="top-resume d-flex justify-content-between mb-40">
                  <div class="title">
                    <div>{{ product.price.product_name }}</div>
                    <div class="text-sm text-white text-opacity-50">{{ interval }}</div>
                  </div>

                  <div class="ps-8">{{ product.price.string }}</div>
                </div>

                <div class="subtotal position-relative d-flex justify-content-between pb-12 mb-40">
                  <span>{{ trans.subtotalText }}</span>

                  <div class="ps-8">{{ product.price.string }}</div>
                </div>

                <div
                  class="iva position-relative text-white text-opacity-50 d-flex justify-content-between pb-12 mb-40">
                  <span>{{ product.taxes.name }}</span>

                  <div class="ps-8">{{ product.taxes.string }}</div>
                </div>

                <div class="total position-relative d-flex justify-content-between pb-12 mb-40">
                  <span>{{ trans.totalText }}</span>

                  <div class="ps-8">{{ product.total_with_taxes.string }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5 form-section">
            <h1 class="h5 text-center mb-16">{{ trans.formTitle }}</h1>

            <p class="text-center mb-36">{{ trans.formSubtitle }}</p>

            <Form ref="form" v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
              <div class="uq-stripe-form-container row">
                <div
                  v-if="!isLoggedIn"
                  class="form-group col-12 mb-16">
                  <label class="form-label">{{ trans.emailLabel }} *</label>

                  <Field
                    id="email"
                    v-model="payment.email"
                    aria-describedby="emailHelp"
                    class="form-control"
                    name="email"
                    type="email"
                  />

                  <ErrorMessage class="invalid-feedback" name="email"/>
                </div>

                <div v-else-if="!!user.email" class="form-group col-12 mb-16">
                  {{ trans.loggedInAs }} {{ user.email }}
                </div>

                <div class="form-group col-12 mb-16">
                  <label class="form-label">{{ trans.nameLabel }} *</label>

                  <Field
                    id="name"
                    v-model="payment.name"
                    aria-describedby="Name"
                    class="form-control"
                    name="name"
                    type="text"
                  />

                  <ErrorMessage class="invalid-feedback" name="name"/>
                </div>

                <div class="form-group col-12 mb-32">
                  <label class="form-label">{{ trans.lastNameLabel }} *</label>

                  <Field
                    id="last-name"
                    v-model="payment.last_name"
                    aria-describedby="Last Name"
                    class="form-control"
                    name="last_name"
                    type="text"
                  />

                  <ErrorMessage class="invalid-feedback" name="last_name"/>
                </div>

                <div class="col-6 pe-0 mb-16">
                  <button
                    :class="{'active': paymentMethod === 'cardMethod'}"
                    class="btn btn-sepa"
                    type="button"
                    @click="paymentMethod = 'cardMethod'">
                    {{ trans.cardButtonText }}
                  </button>
                </div>

                <div class="col-6 ps-0 mb-16">
                  <button
                    :class="{'active': paymentMethod === 'sepaMethod'}"
                    class="btn btn-sepa"
                    type="button"
                    @click="paymentMethod = 'sepaMethod'">
                    {{ trans.sepaButtonText }}
                  </button>
                </div>

                <template v-if="stripe">
                  <stripe-payment-card-method
                    v-if="paymentMethod === 'cardMethod'" ref="cardMethod"
                    :stripe="stripe" :trans="trans"/>

                  <stripe-payment-sepa-method
                    v-else-if="paymentMethod === 'sepaMethod'" ref="sepaMethod"
                    :country="payment.country"
                    :sepa-text="trans.sepaInformationText"
                    :stripe="stripe" :trans="trans"/>
                </template>

                <div class="form-group col-12 mb-16">
                  <label class="form-label">{{ trans.customerLabel + '*' }}</label>

                  <Field
                    id="fiscal_name"
                    v-model="payment.fiscal_name"
                    :placeholder="trans.fiscalLabel + '*'"
                    aria-describedby="FiscalName"
                    class="form-control"
                    name="fiscal_name"
                    type="text"
                  />

                  <ErrorMessage class="invalid-feedback" name="fiscal_name"/>
                </div>

                <div class="form-group billing-address-group mb-16">
                  <label class="form-label d-block mb-0">{{ trans.billingLabel }} *</label>
                  <label class="form-label d-block text-xs">{{ trans.billingInvoiceLabel }}</label>

                  <Field
                    id="country"
                    v-model="payment.country"
                    aria-label="Country"
                    as="select"
                    class="form-select"
                    name="country"
                    @change="getStripeProduct()">
                    <option
                      v-for="(country, index) in countries"
                      :key="index"
                      :value="country.code.toUpperCase()">
                      {{ country.name }}
                    </option>
                  </Field>

                  <ErrorMessage class="invalid-feedback" name="country"/>
                </div>

                <div class="form-group mb-16">
                  <div v-if="countrySelected.id_identity" class="col-12">
                    <Field
                      id="required_id_identity"
                      v-model="payment.required_id_identity"
                      name="required_id_identity"
                      type="hidden"
                    />

                    <Field
                      id="id_identity"
                      v-model="payment.id_identity"
                      aria-describedby="IdIdentity"
                      class="form-control"
                      name="id_identity"
                      placeholder="NIF/CIF*"
                      type="text"
                    />
                    <ErrorMessage class="invalid-feedback" name="id_identity"/>
                  </div>

                  <div v-if="countrySelected.vat" class="col-12">
                    <Field
                      id="required_vat"
                      v-model="payment.required_vat"
                      name="required_vat"
                      type="hidden"
                    />

                    <Field
                      id="vat"
                      v-model="payment.vat"
                      aria-describedby="VAT"
                      class="form-control"
                      name="vat"
                      placeholder="VAT"
                      type="text"
                    />

                    <ErrorMessage class="invalid-feedback" name="vat"/>
                  </div>

                  <span
                    v-if="countrySelected.vat && errors?.length > 0 || countrySelected.id_identity && errors?.length > 0"
                    class="error mb-12 d-block text-md">{{ trans.cifError }}</span>
                </div>

                <div class="form-group col-12">
                  <Field
                    id="line1"
                    v-model="payment.line1"
                    :placeholder="trans.address1Label + '*'"
                    aria-describedby="addressLine1"
                    class="form-control"
                    name="line1"
                    type="text"
                  />
                  <ErrorMessage class="invalid-feedback" name="line1"/>
                </div>

                <div class="form-group col-12">
                  <Field
                    id="line2"
                    v-model="payment.line2"
                    :placeholder="trans.address2Label"
                    aria-describedby="addressLine2"
                    class="form-control"
                    name="line2"
                    type="text"
                  />
                  <ErrorMessage class="invalid-feedback" name="line2"/>
                </div>

                <div class="form-group d-flex flex-wrap">
                  <div class="col-12 col-lg-6">
                    <Field
                      id="postal_code"
                      v-model="payment.postal_code"
                      :placeholder="trans.postalLabel + '*'"
                      aria-describedby="postalCode"
                      class="form-control"
                      name="postal_code"
                      type="text"
                    />

                    <ErrorMessage class="invalid-feedback" name="postal_code"/>
                  </div>

                  <div class="col-12 col-lg-6">
                    <Field
                      id="state"
                      v-model="payment.state"
                      :placeholder="trans.stateLabel + '*'"
                      aria-describedby="state"
                      class="form-control"
                      name="state"
                      type="text"
                    />

                    <ErrorMessage class="invalid-feedback" name="state"/>
                  </div>
                </div>

                <div class="form-group col-12 mb-16">
                  <Field
                    id="city"
                    v-model="payment.city"
                    :placeholder="trans.cityLabel + '*'"
                    aria-describedby="city"
                    class="form-control"
                    name="city"
                    type="text"
                  />
                  <ErrorMessage class="invalid-feedback" name="city"/>
                </div>

                <div class="form-group col-12 mb-16">
                  <label class="form-label">{{ trans.licenseEmailLabel + '*' }}</label>

                  <Field
                    v-if="this.showLicenseEmail"
                    id="license-email"
                    v-model="payment.license_email"
                    aria-describedby="License email"
                    class="form-control"
                    name="license_email"
                    type="email"
                  />

                  <ErrorMessage class="invalid-feedback" name="license_email"/>
                </div>

                <div class="form-group global-checkbox col-12 mb-16">
                  <input id="show-license-email" type="checkbox" @change="toggleLicenseEmail($event)"/>
                  <label class="show-license-email" for="show-license-email">{{ trans.billingEmailLabel }}</label>
                </div>

                <div class="submit-section mb-16 mt-16">
                  <span v-if="errors?.length > 0" class="error mb-12 d-block text-md">
                    {{ errors }}
                  </span>

                  <span v-if="genericError?.length > 0" class="error mb-12 d-block text-md">
                    {{ trans.genericErrorLabel }}
                  </span>

                  <button
                    :class="{ 'btn-loading': disabledButton }"
                    :disabled="disabledButton"
                    class="btn btn-primary btn-process-payment w-100 mb-8"
                    type="button"
                    @click="handleSubmit($event, generateSubscriptionData)">
                    <span v-if="!disabledButton">{{ trans.buttonText }}</span>
                    <template v-else>
                      <span>{{ trans.processingButtonText }}</span>
                      <span class="loader"></span>
                    </template>
                  </button>

                  <div class="col-12 col-lg-8 offset-lg-2 d-flex align-items-center text-center text-xs lh-xxl">
                    {{ trans.confirmText }}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </transition>

      <transition name="loader">
        <div v-if="!product" class="stripe-loader d-flex align-items-center justify-content-center">
          <div class="loader-inner">
            <div class="load loader-1"></div>
            <div class="load loader-2"></div>
            <div class="load loader-3"></div>
            <div class="load loader-4"></div>
            <div class="load loader-5"></div>
            <div class="load loader-6"></div>
            <div class="load loader-7"></div>
            <div class="load loader-8"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>

  <the-checkout-payment-authorization-modal
    v-if="confirm3DSSecureUrl"
    :url="confirm3DSSecureUrl"
    @closed="closeModal"
    @validation-accepted="confirm3DSSecure"
    @validation-cancelled="cancel3DSSecure"
  >
  </the-checkout-payment-authorization-modal>
</template>

<script>
import api from '@assets/js/front/checkout/api';
import * as yup from 'yup';
import { ErrorMessage, Field, Form } from 'vee-validate';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentCardMethod from './StripePaymentCardMethod';
import StripePaymentSepaMethod from './StripePaymentSepaMethod';
import VStripeLoginModal from './VStripeLoginModal';
import TheCheckoutPaymentAuthorizationModal from './TheCheckoutPaymentAuthorizationModal';

export default {
  name: 'VStripePayment',
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
    thankYou: {
      required: true,
      type: String,
    },
  },
  components: {
    VStripeLoginModal,
    Form,
    Field,
    ErrorMessage,
    StripePaymentCardMethod,
    StripePaymentSepaMethod,
    TheCheckoutPaymentAuthorizationModal,
  },
  computed: {
    interval() {
      if (this.product.price.interval === 'year') {
        return 'Yearly billing';
      } else if (this.product.price.interval === 'month') {
        return 'Monthly billing';
      } else {
        return 'We grant you total access to the source code of Evergine.';
      }
    },
  },
  data() {
    return {
      payment: {},
      countries: {},
      countrySelected: {},
      errors: '',
      genericError: '',
      paymentMethod: 'cardMethod',
      selectedStripeId: null,
      stripe: undefined,
      elements: undefined,
      element: undefined,
      product: '',
      confirm3DSSecureUrl: null,
      disabledButton: false,
      showLicenseEmail: true,
      user: {},
      schema: {},

      isLoggedIn: false,
    };
  },
  async mounted() {
    await this.loadCurrentUser();
    await this.loadForm();
  },
  methods: {
    async loadCurrentUser() {
      try {
        this.isLoggedIn = await api.auth.check();

        if (!!this.isLoggedIn) {
          this.user = await api.user.retrieve();
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadForm() {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);

      const spanish = {
        mixed: {
          required: 'El campo es obligatorio',
        },
        string: {
          email: 'Introduce un email válido',
        },
      };

      const english = {
        mixed: {
          required: 'The field is required',
        },
        string: {
          email: 'Email must be a valid email',
        },
      };

      yup.setLocale(this.locale === 'es' ? spanish : english);

      this.schema = yup.object().shape({
        fiscal_name: yup.string().required().label('Fiscal name'),
        name: yup.string().required().nullable().label('Name'),
        last_name: yup.string().required().nullable().label('Last name'),
        line1: yup.string().required().label('Line address'),
        line2: yup.string().nullable(),
        email: yup.lazy(() => {
          if (!this.isLoggedIn) {
            return yup.string().required().email().label('Email');
          } else {
            return yup.string().nullable().email().label('Email');
          }
        }),
        country: yup.string().required().nullable().label('Country'),
        state: yup.string().required().label('State'),
        city: yup.string().required().label('City'),
        postal_code: yup.string().required().label('Postal Code'),
        vat: yup.lazy(() => {
          if (this.countrySelected.vat) {
            return yup.string().required().label('VAT');
          } else {
            return yup.string().nullable().label('VAT');
          }
        }),
        id_identity: yup.lazy(() => {
          if (this.countrySelected.id_identity) {
            return yup.string().required().label('NIF/CIF');
          } else {
            return yup.string().nullable().label('NIF/CIF');
          }
        }),
        license_email: yup.lazy(() => {
          if (this.showLicenseEmail) {
            return yup.string().required().email().label('License email');
          } else {
            return yup.string().nullable().label('License email');
          }
        }),
      });

      if (params.get('price')) {
        this.selectedStripeId = params.get('price');
        this.payment.country = 'US';

        await this.getStripeProduct();

        this.stripe = await loadStripe(`${ process.env.MIX_STRIPE_KEY }`, {
          locale: this.locale,
        });
      } else {
        history.back();
      }
    },
    async getStripeProduct() {
      try {
        this.product = await api.stripe.retrievePrice(this.selectedStripeId, this.payment.country);

        await this.getCountries();
      } catch (e) {
        console.error(e);
      }
    },
    async getCountries() {
      try {
        this.countries = await api.stripe.retrieveCountries();

        await this.setCountrySelected();
      } catch (e) {
        console.error(e);
      }
    },
    async setCountrySelected() {
      this.countrySelected = this.countries.find(
        (country) => country.code.toUpperCase() === this.payment.country,
      );
    },
    async generateSubscriptionData(formData) {
      this.disabledButton = true;
      this.errors = '';

      try {
        let data = {
          name: formData.name,
          last_name: formData.last_name,
          city: formData.city,
          country: formData.country,
          fiscal_name: formData.fiscal_name,
          id_identity: formData.id_identity,
          license_email: this.showLicenseEmail ? formData.license_email : formData.email,
          line1: formData.line1,
          line2: formData.line2,
          postal_code: formData.postal_code,
          state: formData.state,
          vat: formData.vat,
          price_stripe_id: this.selectedStripeId,
          payment_method: this.paymentMethod,
        };

        if (!this.isLoggedIn) {
          data.email = formData.email;
        }

        if (data.payment_method === 'cardMethod') {
          const { token, error } = await this.$refs.cardMethod.createCardToken();

          if (error) {
            let errorElement = this.$refs.cardMethod.$refs.errors;
            errorElement.textContent = error.message;

            this.disabledButton = false;

            return;
          } else {
            data.card_token = token.id;
          }

        } else if (data.payment_method === 'sepaMethod') {
          const { source, error } = await this.$refs.sepaMethod.createIbanSource(
            data.fiscal_name,
            !this.isLoggedIn ? data.email : this.user.email,
          );

          if (error) {
            let errorElement = this.$refs.sepaMethod.$refs.errors;
            errorElement.textContent = error.message;

            this.disabledButton = false;

            return;
          }

          data.iban_source = source.id;
        }

        const response = await api.stripe.checkout(data);

        if (!!response?.redirect_url && response?.status === 'error_3ds') {
          this.confirm3DSSecureUrl = response.redirect_url;

          this.disabledButton = true;
        } else {
          this.disabledButton = false;

          window.location.href = this.thankYou;
        }
      } catch (e) {
        if (e.response?.data?.status === 'unknown_error') {

          this.disabledButton = false;

          if (!!e.response?.data?.message) {
            this.genericError = e.response?.data?.message;
          }

          throw e;

        } else {

          this.disabledButton = false;

          if (!!e.response?.data?.message) {
            this.errors = e.response?.data?.message;
          }

          throw e;

        }
      }
    },
    async confirm3DSSecure() {
      this.confirm3DSSecureUrl = null;

      window.location.href = this.thankYou;
    },
    cancel3DSSecure() {
      this.confirm3DSSecureUrl = null;
      this.loading = false;
      this.disabledButton = false;

      this.loadCurrentUser();
    },
    closeModal() {
      this.confirm3DSSecureUrl = null;
    },
    toggleLicenseEmail(event) {
      this.showLicenseEmail = !event.target.checked;
    },
    registerElements(elements) {
      let displayError = this.errors;

      let errors = {};
      elements.forEach(function (element, idx) {
        element.on('change', function (event) {
          if (event.error) {
            errors[idx] = event.error.message;
            displayError.innerText = event.error.message;
          } else {
            errors[idx] = null;

            // Loop over the saved errors and find the first one, if any.
            let error = Object.keys(errors)
              .sort()
              .reduce(function (maybeFoundError, key) {
                return maybeFoundError || errors[key];
              }, null);

            if (error) {
              // Now that they've fixed the current error, show another one.
              displayError.innerText = error;
            } else {
              displayError.innerText = '';
            }
          }
        });
      });
    },
    /**
     * Destroys the element
     * @return {void}
     */
    destroy() {
      this.element.destroy();
    },
    /**
     * Unmounts the element
     * @return {void}
     */
    unmount() {
      this.element.unmount();
    },
    /**
     * Updates the element
     * @param {string} opts.classes.base The base class applied to the container. Defaults to StripeElement.
     * @param {string} opts.classes.complete The class name to apply when the Element is complete. Defaults to StripeElement--complete.
     * @param {string} opts.classes.empty The class name to apply when the Element is empty. Defaults to StripeElement--empty.
     * @param {string} opts.classes.focus The class name to apply when the Element is focused. Defaults to StripeElement--focus.
     * @param {string} opts.classes.invalid The class name to apply when the Element is invalid. Defaults to StripeElement--invalid.
     * @param {string} opts.classes.webkitAutoFill The class name to apply when the Element has its value autofilled by the browser (only on Chrome and Safari). Defaults to StripeElement--webkit-autofill.
     * @param {Object} opts.style Customize the appearance of this element using CSS properties passed in a Style object.
     * @param {string} opts.value A pre-filled set of values to include in the input (e.g., {postalCode: '94110'}). Note that sensitive card information (card number, CVC, and expiration date) cannot be pre-filled
     * @param {boolean} opts.hidePostalCode Hide the postal code field. Default is false. If you are already collecting a full billing address or postal code elsewhere, set this to true.
     * @param {string} opts.iconStyle Appearance of the icon in the Element. Either solid or default.
     * @param {boolean} opts.hideIcon Hides the icon in the Element. Default is false.
     * @param {boolean} opts.disabled Applies a disabled state to the Element such that user input is not accepted. Default is false.
     */
    update(opts) {
      this.element.update(opts);
    },
  },
};
</script>

<style lang="scss">

$font-size-base: 1rem;
$font-size-base-px: 16;

@import "~@uniqoders/ares/scss/helpers";

.code-bg {
  background: linear-gradient(
      230deg,
      rgba(255, 255, 255, 0.06) 6.7%,
      rgba(255, 255, 255, 0) 65%
  ),
  #151515;
  border: rem(1) solid #262626;
  box-shadow: 0 rem(1) rem(6) rgba(0, 0, 0, 0.25);
  padding-bottom: rem(80);
  padding-top: rem(80);
  color: white;

  > div {
    --bs-gutter-y: 0;
    --bs-gutter-x: 5.313rem;
  }
}

.top-section {
  text-align: left;
  margin-bottom: rem(100);

  .title {
    font-size: rem(18);
    line-height: rem(28);
  }

  .price {
    display: flex;
    align-items: flex-end;
    margin-bottom: rem(20);

    > div {
      margin-bottom: 0;
    }

    .price-type {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: rem(10);
      margin-left: rem(10);
      font-size: rem(12);
      line-height: rem(6);

      .type {
        margin-top: rem(8);
      }
    }
  }
}

.bottom-section {
  .subtotal,
  .iva,
  .total {
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: rem(1);
      width: 100%;
      background: #262626;
    }
  }

  .image-container {
    img {
      max-width: rem(50);
    }
  }
}

.btn-sepa {
  width: 100%;
  border-radius: 0;
  border: rem(1) solid rgba(255, 255, 255, 0.3);
  padding-top: rem(12);
  padding-bottom: rem(12);

  &.active {
    background-color: var(--uq-light);
    color: var(--uq-primary);
  }

  &:focus {
    box-shadow: 0 0 0 0.25rem rgb(57 93 255 / 50%);
  }

  &:not(.active) {
    color: var(--uq-white-rgb);

    &:hover {
      background-color: var(--uq-primary);
    }
  }
}

.btn-process-payment {
  &.btn-loading {
    position: relative;

    span.loader {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      color: #FFFFFF;
      font-size: 1.5rem;
      overflow: hidden;
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 50%;
      margin: 0 auto;
      transform: translate(-50%, -50%) translateZ(0);
      animation: load6 1.7s infinite ease, round 1.7s infinite ease;
      z-index: 100;
    }
  }
}

.stripe-loader {
  min-height: rem(500);

  .loader-inner {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    .load {
      animation: roller-loader 2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      transform-origin: 40px 40px;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        margin: -4px 0 0 -4px;
      }
    }

    .loader-1 {
      animation-delay: -0.036s;

      &:after {
        top: 63px;
        left: 63px;
      }
    }

    .loader-2 {
      animation-delay: -0.072s;

      &:after {
        top: 68px;
        left: 56px;
      }
    }

    .loader-3 {
      animation-delay: -0.108s;

      &:after {
        top: 71px;
        left: 48px;
      }
    }

    .loader-4 {
      animation-delay: -0.144s;

      &:after {
        top: 72px;
        left: 40px;
      }
    }

    .loader-5 {
      animation-delay: -0.18s;

      &:after {
        top: 71px;
        left: 32px;
      }
    }

    .loader-6 {
      animation-delay: -0.216s;

      &:after {
        top: 68px;
        left: 24px;
      }
    }

    .loader-7 {
      animation-delay: -0.252s;

      &:after {
        top: 63px;
        left: 17px;
      }
    }

    .loader-8 {
      animation-delay: -0.288s;

      &:after {
        top: 56px;
        left: 12px;
      }
    }

    @keyframes roller-loader {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.product-enter-active,
.loader-enter-active {
  animation: fadeIn .8s cubic-bezier(0.5, 0, 0.5, 1);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
